var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[_c('h3',[_vm._v("Promotions")]),_vm._l((_vm.promotions),function(coupon){return _c('Toggle',{key:coupon.id,attrs:{"data":coupon,"action":_vm.toggleCoupon}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }